<template>
  <a-checkbox-group v-if="tagType=='checkbox'" @change="onChange" :value="arrayValue" :disabled="disabled">
    <a-checkbox v-for= '(item, key) in dictOptions ' :key= 'key ' :value= 'item.value '>
      {{ item.text || item.label }}
    </a-checkbox>
  </a-checkbox-group>

  <a-select
      v-else-if="tagType=='select'"
      :value="arrayValue"
      mode="multiple"
      :disabled="disabled"
      :placeholder="placeholder"
      @change="onChange"
      allowClear>
    <a-select-option v-for="(item,index) in dictOptions" :key="index" :value="item.value">
      <span style="display: inline-block;width: 100%" :title="item.text || item.label">
        {{ item.text || item.label }}
      </span>
    </a-select-option>
  </a-select>

</template>

<script>
import Vue from 'vue'
import { ajaxGetDictItems, ajaxGetDictItemsForUrl, getDictItemsFromCache } from '@/api/api'

export default {
  name: 'JMultiSelectTag',
  props: {
    dictCode: String,
    url: String,
    placeholder: String,
    disabled: Boolean,
    value: String,
    type: String,
    options: Array
  },
  data() {
    return {
      dictOptions: [],
      tagType: '',
      arrayValue: !this.value ? [] : this.value.split(',')
    }
  },
  created() {
    if (!this.type || this.type === 'multi') {
      this.tagType = 'select'
    } else {
      this.tagType = this.type
    }
  },
  watch: {
    options: function (val) {
      this.setCurrentDictOptions(val)
    },
    url: {
      immediate: true,
      handler() {
        this.initDictData()
      }
    },
    dictCode: {
      immediate: true,
      handler() {
        this.initDictData()
      }
    },
    value(val) {
      if (!val) {
        this.arrayValue = []
      } else {
        this.arrayValue = this.value.split(',')
      }
    }
  },
  methods: {
    initDictData() {
      if (this.options && this.options.length > 0) {
        this.dictOptions = [...this.options]
      } else {
        // 优先从缓存中读取字典配置
        if (getDictItemsFromCache(this.dictCode)) {
          this.dictOptions = getDictItemsFromCache(this.dictCode)
        } else if (this.url) {
          ajaxGetDictItemsForUrl(this.url).then((res) => {
            if (res.success) {
              if (res.result.records) {
                this.dictOptions = res.result.records
                return
              }
              this.dictOptions = res.result
            }
          })
        } else if (this.dictCode) {
          // 根据字典Code, 初始化字典数组
          ajaxGetDictItems(this.dictCode, null).then((res) => {
            if (res.success) {
              if (res.result.records && res.result.records.length > 0) {
                Vue.ls.set('cache_dict_data:' + this.dictCode, res.result.records)
                this.dictOptions = res.result.records
              } else if (res.result && res.result.length > 0) {
                Vue.ls.set('cache_dict_data:' + this.dictCode, res.result)
                this.dictOptions = res.result
              }
            } else {
              this.dictOptions = []
            }
          })
        }
      }
    },
    onChange(selectedValue) {
      this.$emit('change', selectedValue.join(','))
    },
    setCurrentDictOptions(dictOptions) {
      this.dictOptions = dictOptions
    },
    getCurrentDictOptions() {
      return this.dictOptions
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dict/JMultiSelectTag.vue